import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getProductosSemanaHomeSelected,
  updateSelecteProductosSemanaHome,
} from 'services/configuracionPortal'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_PRODUCTOS_SEMANA_HOME_SELECTED(action) {
  try {
    const categoriaHomeData = yield call(getProductosSemanaHomeSelected, action.payload)
    if (categoriaHomeData.ok) {
      yield put({
        type: actions.PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_SUCCEEDED,
        payload: categoriaHomeData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Productos Semana Home seleccionadas')
      put({
        type: actions.PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_PRODUCTOS_SEMANA_HOME_SELECTED(action) {
  try {
    const categoriaHomeObj = yield call(updateSelecteProductosSemanaHome, action.payload)
    if (categoriaHomeObj.ok) {
      putMessage(
        messageType.SUCCESS,
        'Productos Semana Home seleccionados, modificados correctamente',
      )
      yield put({
        type: actions.PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_SUCCEEDED,
        payload: categoriaHomeObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Productos Semana Home seleccionadas')
      yield put({
        type: actions.PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Productos Semana Home seleccionadas')
    yield all([
      put({
        type: actions.PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(
      actions.PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_REQUESTED,
      GET_PRODUCTOS_SEMANA_HOME_SELECTED,
    ),
    takeEvery(
      actions.PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_REQUESTED,
      UPDATE_PRODUCTOS_SEMANA_HOME_SELECTED,
    ),
  ])
}
